import { render, staticRenderFns } from "./VersionSwitcher.vue?vue&type=template&id=c4dae0be"
import script from "./VersionSwitcher.vue?vue&type=script&lang=js"
export * from "./VersionSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports